export var AppInterfaceAmministroio;
(function (AppInterfaceAmministroio) {
    AppInterfaceAmministroio["ALFRED"] = "ALFRED";
    AppInterfaceAmministroio["INSERVIZIO"] = "INSERVIZIO";
    AppInterfaceAmministroio["CRUSCOTTO"] = "CRUSCOTTO";
    AppInterfaceAmministroio["CRMCITYCLOUD"] = "CRMCITYCLOUD";
    AppInterfaceAmministroio["CRMSFERA"] = "CRMSFERA";
    AppInterfaceAmministroio["CRMCONDOMINIO"] = "CRMCONDOMINIO";
    AppInterfaceAmministroio["CRMVALORE24"] = "CRMVALORE24";
    AppInterfaceAmministroio["JARVIS"] = "JARVIS";
})(AppInterfaceAmministroio || (AppInterfaceAmministroio = {}));
export const appInterfaceAmministroValues = Object.values(AppInterfaceAmministroio);
/**
 * @deprecated `AppInterfaceAmministroio.ALFRED`
 */
export const ALFRED = AppInterfaceAmministroio.ALFRED;
/**
 * @deprecated `AppInterfaceAmministroio.INSERVIZIO`
 */
export const INSERVIZIO = AppInterfaceAmministroio.INSERVIZIO;
/**
 * @deprecated `AppInterfaceAmministroio.CRUSCOTTO`
 */
export const CRUSCOTTO = AppInterfaceAmministroio.CRUSCOTTO;
export var AppInterfaceArchivioplus;
(function (AppInterfaceArchivioplus) {
    AppInterfaceArchivioplus["TEAPOT"] = "TEAPOT";
})(AppInterfaceArchivioplus || (AppInterfaceArchivioplus = {}));
export const appInterfaceArchivioplusValues = Object.values(AppInterfaceArchivioplus);
/**
 * @deprecated Use `AppInterfaceArchivioplus.TEAPOT`
 */
export const TEAPOT = AppInterfaceArchivioplus.TEAPOT;
export var AppInterfaceNotificoonline;
(function (AppInterfaceNotificoonline) {
    AppInterfaceNotificoonline["DOORBELL"] = "DOORBELL";
})(AppInterfaceNotificoonline || (AppInterfaceNotificoonline = {}));
export const appInterfaceNotificoonlineValues = Object.values(AppInterfaceNotificoonline);
/**
 * @deprecated Use `AppInterfaceNotificoonline.DOORBELL`
 */
export const DOORBELL = AppInterfaceNotificoonline.DOORBELL;
